import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext"; // 確保路徑正確
// import { Auth } from 'aws-amplify';

function OrgLoginPage() {
  const [organisationID, setOrganisationID] = useState("");
  const [adminID, setAdminID] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [currentStep, setCurrentStep] = useState("login"); // "login", "verification", "success"
  const navigate = useNavigate();
  const { login } = useContext(AuthContext); // 使用AuthContext的login函數

  useEffect(() => {
    setTimeout(() => {
      setShowForm(true);
    }, 500);
    
    // 檢查本地存儲的登入信息
    checkPreviousLogin();
  }, []);

  const checkPreviousLogin = () => {
    const previousLoginInfo = localStorage.getItem('loginInfo');
    
    if (previousLoginInfo) {
      const parsedInfo = JSON.parse(previousLoginInfo);
      // 自動填充ID
      setOrganisationID(parsedInfo.organisationID || "");
      setAdminID(parsedInfo.adminID || "");
    }
  };

  const handleInitialLogin = () => {
    setLoading(true);
    setError("");
    
    const validCredentials = [
      { organisationID: "H48", adminID: "83", orgName: "Swissotel Clark", adminName: "Admin1", orgEmail: "xxx@abc.com" },
      { organisationID: "H72", adminID: "91", orgName: "Parkinn Clark", adminName: "Admin1", orgEmail: "xxx@abc.com" },
      { organisationID: "H77", adminID: "64", orgName: "Reef Cebu", adminName: "Admin1", orgEmail: "xxx@abc.com" },
      { organisationID: "H28", adminID: "68", orgName: "Midas Manila", adminName: "Admin1", orgEmail: "xxx@abc.com" },
      { organisationID: "H16", adminID: "31", orgName: "Shangri-la Cebu", adminName: "Admin1", orgEmail: "xxx@abc.com" },
      { organisationID: "H11", adminID: "25", orgName: "Marriott Spa Clark", adminName: "Admin1" , orgEmail: "xxx@abc.com"},
      { organisationID: "S38", adminID: "89", orgName: "Okada Spa", adminName: "Admin1", orgEmail: "xxx@abc.com" },
      { organisationID: "S69", adminID: "30", orgName: "Swissotel Spa", adminName: "Admin1", orgEmail: "xxx@abc.com" },
      { organisationID: "S93", adminID: "15", orgName: "Marriott Spa Clark", adminName: "Admin1", orgEmail: "xxx@abc.com" },
    ];

    const matchedCredential = validCredentials.find(
      (cred) => cred.organisationID === organisationID && cred.adminID === adminID
    );

    // 檢查是否找到匹配的憑證
    if (!matchedCredential) {
      setLoading(false);
      setError("Invalid credentials. Please try again.");
      return;
    }

    // 檢查上次登入信息
    const previousLoginInfo = localStorage.getItem('loginInfo');
    const currentLoginInfo = {
      organisationID,
      adminID,
      browser: navigator.userAgent,
      device: window.innerWidth <= 768 ? 'mobile' : 'desktop',
      timestamp: new Date().toISOString(),
    };
    
    // 如果上次登入信息存在且與當前登入信息一致，直接登入
    if (previousLoginInfo) {
      const parsedInfo = JSON.parse(previousLoginInfo);
      if (parsedInfo.organisationID === organisationID && 
          parsedInfo.adminID === adminID && 
          parsedInfo.browser === currentLoginInfo.browser && 
          parsedInfo.device === currentLoginInfo.device) {
        
        // 跳過驗證
        completeLogin(matchedCredential, currentLoginInfo);
        return;
      }
    }
    
    // 需要電郵驗證
    // 模擬發送驗證碼
    sendVerificationCode(matchedCredential);
  };

  const sendVerificationCode = (credential) => {
    // 在實際情況下，這裡會調用AWS SES或Cognito發送驗證碼
    console.log(`Sending verification code to: ${credential.orgEmail}`);
    
    // 模擬API調用發送驗證碼
    setTimeout(() => {
      setLoading(false);
      // 轉到驗證頁面
      setCurrentStep("verification");
      
      // 存儲當前憑證以便驗證時使用
      sessionStorage.setItem('tempCredential', JSON.stringify(credential));
      
      // 在測試環境下，我們假設生成的驗證碼是123456
      console.log("Test verification code: 123456");
    }, 2000);
  };

  const handleVerification = () => {
    setLoading(true);
    setError("");
    
    // 獲取暫存的憑證
    const tempCredentialStr = sessionStorage.getItem('tempCredential');
    if (!tempCredentialStr) {
      setError("Session expired. Please try again.");
      setLoading(false);
      return;
    }
    
    const tempCredential = JSON.parse(tempCredentialStr);
    
    // 在實際情況下，這裡會驗證用戶輸入的代碼
    // 與AWS Cognito或其他服務中存儲的代碼
    
    // 模擬驗證過程
    setTimeout(() => {
      setLoading(false);
      
      // 在測試環境中，我們假設正確的驗證碼是123456
      if (verificationCode === "123456") {
        // 創建當前登入信息
        const currentLoginInfo = {
          organisationID,
          adminID,
          browser: navigator.userAgent,
          device: window.innerWidth <= 768 ? 'mobile' : 'desktop',
          timestamp: new Date().toISOString(),
        };
        
        // 完成登入流程
        completeLogin(tempCredential, currentLoginInfo);
      } else {
        setError("Invalid verification code. Please try again.");
      }
    }, 1500);
  };
  
  const completeLogin = (credential, loginInfo) => {
    // 儲存登入信息
    localStorage.setItem('loginInfo', JSON.stringify(loginInfo));
    
    // 設置用戶身份信息
    login({
      id: credential.adminID,
      organisationID: credential.organisationID,
      role: "orgAdmin", // 為組織管理員設置特定角色
      orgName: credential.orgName,
      name: credential.adminName
    });
    
    // 顯示成功訊息
    setCurrentStep("success");
    setSuccess(true);
    
    // 清除臨時數據
    sessionStorage.removeItem('tempCredential');
    
    // 等待顯示成功信息後再跳轉
    setTimeout(() => {
      navigate(`/org/${credential.organisationID}/${credential.adminID}/db`);
    }, 2000);
  };

  const renderLoginForm = () => (
    <>
      <div style={styles.inputGroup}>
        <label style={styles.label}>Organisation ID</label>
        <div style={styles.inputWrapper}>
          <input
            type="text"
            value={organisationID}
            onChange={(e) => setOrganisationID(e.target.value)}
            style={styles.input}
            placeholder="Enter Organisation ID"
          />
          <div style={styles.inputBorder}></div>
        </div>
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label}>Admin ID</label>
        <div style={styles.inputWrapper}>
          <input
            type="password"
            value={adminID}
            onChange={(e) => setAdminID(e.target.value)}
            style={styles.input}
            placeholder="Enter Admin ID"
          />
          <div style={styles.inputBorder}></div>
        </div>
      </div>

      <button 
        onClick={handleInitialLogin} 
        style={loading ? {...styles.button, ...styles.buttonLoading} : styles.button}
        disabled={loading}
      >
        {loading ? (
          <div style={styles.spinnerContainer}>
            <div style={styles.spinner}></div>
          </div>
        ) : "CONTINUE"}
      </button>
    </>
  );

  const renderVerificationForm = () => (
    <>
      <div style={styles.verificationInfo}>
        <p style={styles.verificationText}>
          A verification code has been sent to your organization's email.
          Please enter the code below.
        </p>
      </div>
      
      <div style={styles.inputGroup}>
        <label style={styles.label}>Verification Code</label>
        <div style={styles.inputWrapper}>
          <input
            type="text"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            style={styles.input}
            placeholder="Enter 6-digit code"
            maxLength="6"
            autoFocus
          />
          <div style={styles.inputBorder}></div>
        </div>
      </div>

      <button 
        onClick={handleVerification} 
        style={loading ? {...styles.button, ...styles.buttonLoading} : styles.button}
        disabled={loading}
      >
        {loading ? (
          <div style={styles.spinnerContainer}>
            <div style={styles.spinner}></div>
          </div>
        ) : "VERIFY & LOGIN"}
      </button>
      
      <button 
        onClick={() => setCurrentStep("login")} 
        style={styles.backButton}
      >
        Back to Login
      </button>
    </>
  );

  const renderCurrentStep = () => {
    switch (currentStep) {
      case "verification":
        return renderVerificationForm();
      case "success":
        return null; // 成功信息顯示在另一個地方
      default:
        return renderLoginForm();
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.backgroundOverlay}></div>
      <div 
        style={{
          ...styles.card,
          opacity: showForm ? 1 : 0,
          transform: showForm ? 'translateY(0)' : 'translateY(20px)'
        }}
      >
        <div style={styles.logoContainer}>
          <div style={styles.logoCircle}>
            <span style={styles.logoText}>KL</span>
          </div>
        </div>
        
        <h1 style={styles.title}>KAT LAI Technology</h1>
        <p style={styles.subtitle}>Aroma Pod Pro Therapeutic System</p>

        <div style={styles.formContainer}>
          {error && <p style={styles.error}>{error}</p>}
          
          {success && (
            <div style={styles.successMessage}>
              <svg style={styles.checkmark} viewBox="0 0 52 52">
                <circle style={styles.checkmarkCircle} cx="26" cy="26" r="25" fill="none" />
                <path style={styles.checkmarkCheck} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
              </svg>
              <p style={styles.success}>Login successful! Welcome to the Aroma Pod Pro Therapeutic System</p>
            </div>
          )}
          
          {!success && renderCurrentStep()}
          
          <div style={styles.securityNote}>
            <div style={styles.securityIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <span style={styles.securityText}>Secure Encrypted Connection</span>
          </div>
        </div>
        
        <div style={styles.footer}>
          <p>© 2025 KAT LAI Technology - Pioneering Biotechnology Solutions</p>
        </div>
      </div>
      
      <div style={styles.particlesContainer}>
        {[...Array(15)].map((_, i) => (
          <div 
            key={i} 
            style={{
              ...styles.particle,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              width: `${Math.random() * 10 + 2}px`,
              height: `${Math.random() * 10 + 2}px`,
              opacity: 0.2 + Math.random() * 0.3,
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}

const keyframes = `
  @keyframes float {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(5deg); }
  }
  
  @keyframes pulse {
    0% { opacity: 0.1; transform: scale(1); }
    50% { opacity: 0.3; transform: scale(1.05); }
    100% { opacity: 0.1; transform: scale(1); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes draw {
    0% { stroke-dashoffset: 166; }
    100% { stroke-dashoffset: 0; }
  }
  
  @keyframes fillCheckmark {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  
  @keyframes borderFocus {
    0% { width: 0; }
    100% { width: 100%; }
  }
  
  @keyframes shimmer {
    0% { background-position: -1000px 0; }
    100% { background-position: 1000px 0; }
  }
`;

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#dfd3c3", // Warm earth tone background
    position: "relative",
    overflow: "hidden",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', 'Baskerville', serif",
  },
  backgroundOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "radial-gradient(ellipse at center, rgba(191, 172, 150, 0.4) 0%, rgba(141, 110, 99, 0.7) 100%)",
    zIndex: 1,
  },
  particlesContainer: {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 2,
  },
  particle: {
    position: "absolute",
    backgroundColor: "#f0e6d9",
    borderRadius: "50%",
    animation: "pulse 8s infinite ease-in-out",
    zIndex: 2,
  },
  card: {
    backgroundColor: "rgba(250, 245, 240, 0.95)",
    backdropFilter: "blur(10px)",
    borderRadius: "8px",
    boxShadow: "0 10px 25px rgba(108, 93, 83, 0.15), 0 0 50px rgba(217, 195, 170, 0.1)",
    padding: "40px",
    width: "440px",
    textAlign: "center",
    transition: "all 0.6s ease-out",
    zIndex: 10,
    position: "relative",
    overflow: "hidden",
    border: "1px solid rgba(217, 195, 170, 0.2)",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "25px",
  },
  logoCircle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    backgroundColor: "#8d6e63",
    background: "linear-gradient(135deg, #a1887f, #8d6e63)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 10px rgba(141, 110, 99, 0.3)",
  },
  logoText: {
    color: "#f5f0ec",
    fontWeight: "bold",
    fontSize: "22px",
    letterSpacing: "1px",
  },
  title: {
    fontSize: "26px",
    fontWeight: "600",
    color: "#6d4c41",
    margin: "0 0 5px 0",
    letterSpacing: "0.5px",
  },
  subtitle: {
    fontSize: "16px",
    color: "#a18072",
    marginBottom: "35px",
    fontWeight: "400",
    letterSpacing: "0.5px",
  },
  formContainer: {
    textAlign: "left",
    marginBottom: "20px",
  },
  inputGroup: {
    marginBottom: "24px",
    position: "relative",
  },
  label: {
    display: "block",
    fontSize: "14px",
    color: "#8d6e63",
    marginBottom: "8px",
    fontWeight: "500",
    letterSpacing: "0.5px",
  },
  inputWrapper: {
    position: "relative",
  },
  input: {
    width: "100%",
    padding: "14px 15px",
    fontSize: "15px",
    border: "1px solid rgba(217, 195, 170, 0.5)",
    borderRadius: "4px",
    outline: "none",
    boxSizing: "border-box",
    color: "#5d4037",
    backgroundColor: "rgba(250, 248, 246, 0.9)",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 5px rgba(141, 110, 99, 0.05)",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
  },
  inputBorder: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    height: "2px",
    width: "0",
    backgroundColor: "#a18072",
    transition: "width 0.3s ease",
  },
  button: {
    width: "100%",
    padding: "14px",
    fontSize: "15px",
    fontWeight: "500",
    backgroundColor: "#8d6e63",
    background: "linear-gradient(135deg, #a1887f, #8d6e63)",
    color: "#f9f5f1",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 12px rgba(141, 110, 99, 0.25)",
    letterSpacing: "2px",
    marginTop: "15px",
    position: "relative",
    overflow: "hidden",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
  },
  backButton: {
    width: "100%",
    padding: "10px",
    fontSize: "14px",
    fontWeight: "400",
    backgroundColor: "transparent",
    color: "#8d6e63",
    border: "1px solid #d7ccc8",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginTop: "15px",
    position: "relative",
    overflow: "hidden",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
  },
  buttonLoading: {
    backgroundColor: "#7d6056",
    cursor: "default",
    boxShadow: "0 4px 8px rgba(141, 110, 99, 0.15)",
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "20px",
  },
  spinner: {
    width: "20px",
    height: "20px",
    border: "3px solid rgba(245, 240, 235, 0.3)",
    borderRadius: "50%",
    borderTopColor: "#f5f0eb",
    animation: "spin 0.8s linear infinite",
  },
  error: {
    color: "#bf360c",
    fontSize: "14px",
    margin: "12px 0",
    padding: "10px",
    backgroundColor: "rgba(191, 54, 12, 0.08)",
    borderRadius: "4px",
    textAlign: "center",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
  },
  successMessage: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10px",
    marginBottom: "10px",
  },
  checkmark: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    display: "block",
    strokeWidth: "2",
    stroke: "#5d9b6a",
    strokeMiterlimit: "10",
    boxShadow: "inset 0px 0px 0px #5d9b6a",
    marginBottom: "10px",
  },
  checkmarkCircle: {
    strokeDasharray: "166",
    strokeDashoffset: "166",
    strokeWidth: "2",
    stroke: "#5d9b6a",
    fill: "none",
    animation: "draw 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards",
  },
  checkmarkCheck: {
    strokeDasharray: "48",
    strokeDashoffset: "48",
    strokeWidth: "2",
    stroke: "#5d9b6a",
    fill: "none",
    animation: "draw 0.3s 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards",
  },
  success: {
    color: "#5d9b6a",
    fontSize: "14px",
    fontWeight: "500",
    textAlign: "center",
    animation: "fillCheckmark 0.3s ease-in-out 0.9s forwards",
    opacity: 0,
    fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
  },
  securityNote: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "25px",
    color: "#a18072",
    fontSize: "13px",
  },
  securityIcon: {
    marginRight: "5px",
    display: "flex",
    alignItems: "center",
    color: "#a18072",
  },
  securityText: {
    color: "#a18072",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
    letterSpacing: "0.3px",
  },
  footer: {
    position: "absolute",
    bottom: "15px",
    left: 0,
    right: 0,
    fontSize: "12px",
    color: "#a18072",
    textAlign: "center",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
    letterSpacing: "0.3px",
  },
  verificationInfo: {
    marginBottom: "20px",
    textAlign: "center",
  },
  verificationText: {
    fontSize: "14px",
    color: "#8d6e63",
    lineHeight: "1.5",
  },
};

// Insert the CSS keyframes
document.head.appendChild(document.createElement('style')).textContent = keyframes;

export default OrgLoginPage;